module.exports = __webpack_public_path__ + "static/media/ICCCNT Certificate.376df0a7.jpeg";